// frontend/src/app/utils/toProductLite.ts
export type Product = {
  id?: string;
  productID?: string;
  productId?: string;
  slug?: string;
  uid?: string;
  title?: string;
  [k: string]: unknown;
};

export function toProductLite<T extends Product>(p: T) {
  return {
    ...p,
    productID: String(p?.productID ?? p?.id ?? p?.productId ?? p?.slug ?? p?.uid ?? ''),
    title: String((p as any)?.title ?? (p as any)?.name ?? (p as any)?.productTitle ?? (p?.id ?? '')),
  };
}
